module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Zuat’s Philosophy")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch002#about-the-book"
    }
  }, [_vm._v("About the Book")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch004#chapter-1"
    }
  }, [_vm._v("Chapter 1")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch004#becoming-the-boss-ready-or-not"
    }
  }, [_vm._v("Becoming the Boss, Ready or Not")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#chapter-2"
    }
  }, [_vm._v("Chapter 2")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch005#the-non-visitor"
    }
  }, [_vm._v("The Non-Visitor")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch006#chapter-3"
    }
  }, [_vm._v("Chapter 3")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch006#what-mattered-most"
    }
  }, [_vm._v("What Mattered Most")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch007#chapter-4"
    }
  }, [_vm._v("Chapter 4")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch007#biblical-babble-ons"
    }
  }, [_vm._v("Biblical Babble-Ons")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#chapter-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#people-digitally-simplified",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("People, Digitally Simplified")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#chapter-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#no-love-under-the-blanket",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No Love Under the Blanket")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#chapter-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#breaking-the-llamas-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breaking the Llama’s Back")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch011#chapter-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch011#someone-else-cared",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Someone Else Cared")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch012#chapter-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch012#anxieties-near-and-far",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anxieties Near and Far")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch013#chapter-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch013#the-knives-of-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Knives of Life")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch014#chapter-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch014#many-separations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Many Separations")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch015#chapter-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch015#the-illusion-of-independence",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Illusion of Independence")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch016#chapter-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch016#strategic-operations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strategic Operations")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch017#chapter-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch017#an-el-cheapo-decision",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An El Cheapo Decision")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch018#chapter-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch018#a-new-view-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New View (1)")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch019#chapter-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch019#a-new-view-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A New View (2)")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch020#chapter-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch020#paper-thin-clues",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paper-Thin Clues")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch021#chapter-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch021#shades-of-persuasion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shades of Persuasion")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch022#chapter-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch022#first-steps-on-the-path",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Steps on the Path")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch023#chapter-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch023#t.-t.-target-teagan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T. T. = Target Teagan")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch024#chapter-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch024#patient-accumulation-of-assets",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patient Accumulation of Assets")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch025#chapter-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch025#almost-nothing-happened",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Almost Nothing Happened")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch026#chapter-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch026#steering-clear-of-the-wild-west",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Steering Clear of the Wild West")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch027#chapter-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch027#widening-the-view",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Widening the View")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch028#chapter-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch028#some-police-do-work",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Police Do Work")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch029#chapter-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch029#arrivals-and-departures",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arrivals and Departures")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch030#chapter-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch030#no-more-good-books",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No More Good Books")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch031#chapter-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch031#yielding-to-tent-tation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yielding to Tent-Tation")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b9df236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/nav.vue
// module id = 60
// module chunks = 0